/**
 * Shared copy for OAuth popups that cannot start in this environment.
 * Platform-specific codes stay in the Instagram/Facebook mappers.
 */
export function oauthEnvironmentMessageKey(
  platform: "instagram" | "facebook",
  code: string,
): string | null {
  if (code === "PLATFORM_NOT_ENABLED") return "channels.platformDisabled";
  if (code !== "FEATURE_DISABLED" && code !== "NOT_CONFIGURED") return null;
  return platform === "instagram" ? "instagram.disabled.message" : "facebook.disabled.message";
}

export function facebookOauthErrorMessageKey(code: string): string {
  return oauthEnvironmentMessageKey("facebook", code) ?? "facebook.popupError.generic";
}
